var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.16666H5.83333M17.5 4.16666H9.16667M2.5 9.99999H12.5M17.5 9.99999H15.8333M2.5 15.8333H4.16667M17.5 15.8333H7.5",
    stroke: "#FFFFFD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49992 5.83333C8.42039 5.83333 9.16659 5.08714 9.16659 4.16667C9.16659 3.24619 8.42039 2.5 7.49992 2.5C6.57944 2.5 5.83325 3.24619 5.83325 4.16667C5.83325 5.08714 6.57944 5.83333 7.49992 5.83333Z",
    stroke: "#FFFFFD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.6667C15.0871 11.6667 15.8333 10.9205 15.8333 10C15.8333 9.07954 15.0871 8.33334 14.1667 8.33334C13.2462 8.33334 12.5 9.07954 12.5 10C12.5 10.9205 13.2462 11.6667 14.1667 11.6667Z",
    stroke: "#FFFFFD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 17.5C6.75389 17.5 7.50008 16.7538 7.50008 15.8333C7.50008 14.9128 6.75389 14.1667 5.83341 14.1667C4.91294 14.1667 4.16675 14.9128 4.16675 15.8333C4.16675 16.7538 4.91294 17.5 5.83341 17.5Z",
    stroke: "#FFFFFD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.75bf34073bab2b56fb3fb676d1f8a435.svg";
export { ForwardRef as ReactComponent };